const handler = ( $ ) => {
	$( document ).ready( function ( $ ) {
		const $containers = $( '.ginput_container_fileupload' );

		$( document ).on( 'click', '.form-submit-wrapper', function ( e ) {
			var $wrapper = $( this );
			var $button = $wrapper.find(
				'input[type="submit"], button[type="submit"]'
			);

			// Prevent duplicate submissions
			if ( $wrapper.hasClass( 'is-sending' ) ) {
				e.preventDefault();
				e.stopPropagation();
				return;
			}

			if ( $button.length && ! $( e.target ).is( $button ) ) {
				e.preventDefault();
				e.stopPropagation();

				if (
					window.gform &&
					window.gform.submission &&
					window.gform.submission.handleButtonClick
				) {
					window.gform.submission.handleButtonClick( $button[ 0 ] );
				} else {
					$button.trigger( 'click' );
				}
			}

			if ( $( '.get-in-touch-page' ).length ) {
				// Get-in-touch: change button text and disable — no spinner
				var originalText = $button.is( 'input' )
					? $button.val()
					: $button.text();
				$wrapper.data( 'original-text', originalText );

				if ( $button.is( 'input' ) ) {
					$button.val( 'Sending…' );
				} else {
					$button.text( 'Sending…' );
				}
				$button.prop( 'disabled', true );
				$wrapper.addClass( 'is-sending' );
			} else {
				$wrapper.hide();

				// Show the loader (make sure to add this div after the button)
				if ( $( '#form_loader' ).length === 0 ) {
					$wrapper.after(
						'<div id="form_loader"><div class="spinner-ring"><img src="/wp-content/themes/bilberrry/assets/images/loader.gif" alt="Loader image" /></div></div>'
					);
				}
				$( '#form_loader' ).show();
			}
		} );

		// Scroll to right-content heading after successful submission
		function scrollToFormTop() {
			if ( ! $( '.get-in-touch-page' ).length ) return;
			var $target = $( '.get-in-touch-page .right-content' );
			if ( ! $target.length ) return;
			var headerHeight = $( 'header' ).outerHeight() || 80;
			var adminBarHeight = $( '#wpadminbar' ).outerHeight() || 0;
			var offset = 24;
			$( 'html, body' ).animate(
				{ scrollTop: $target.offset().top - headerHeight - adminBarHeight - offset },
				400
			);
		}

		// AJAX submission success
		$( document ).on( 'gform_confirmation_loaded', function ( event, formId ) {
			scrollToFormTop();
		} );

		// Non-AJAX: page reloaded with confirmation already visible
		if (
			$( '.get-in-touch-page .gform_confirmation_wrapper' ).length ||
			$( '.get-in-touch-page .gform_confirmation_message' ).length
		) {
			scrollToFormTop();
		}

		// Restore button if GF re-renders (validation error on get-in-touch form)
		$( document ).on( 'gform_post_render', function () {
			if ( ! $( '.get-in-touch-page' ).length ) return;
			var $wrapper = $( '.get-in-touch-page .form-submit-wrapper' );
			var $button = $wrapper.find( 'input[type="submit"], button[type="submit"]' );
			var original = $wrapper.data( 'original-text' ) || 'Send message';

			if ( $button.is( 'input' ) ) {
				$button.val( original );
			} else {
				$button.text( original );
			}
			$button.prop( 'disabled', false );
			$wrapper.removeClass( 'is-sending' );
		} );
		$( '.link-button-wrapper' ).on( 'click', function ( e ) {
			if ( ! $( e.target ).is( 'a.link' ) ) {
				$( this ).find( 'a.link' )[ 0 ].click();
			}
		} );

		$( 'form select:not(#mobile-choice)' ).niceSelect();

		function initCustomUploads( formId ) {
			const $containers = $( '#gform_wrapper_' + formId ).find(
				'.ginput_container_fileupload'
			);

			$containers.each( function () {
				const $thisContainer = $( this );
				const $parentField = $thisContainer.closest( '.gfield' );
				const originalDesc =
					typeof getUploadText === 'function'
						? getUploadText( $thisContainer )
						: '';

				// 1. Hide original descriptions and rules
				$parentField
					.find( '.gfield_description, .gform_fileupload_rules' )
					.not( '.gfield_validation_message' )
					.hide();

				// 2. Inject custom UI if not already there
				if (
					$thisContainer.find( '.custom-upload-content' ).length === 0
				) {
					$thisContainer.prepend( `
                <div class="custom-upload-content">
                    <span class="custom-upload-icon icon-attachment"></span>
                    <span class="custom-upload-text" data-original-text="${ originalDesc }">${ uploadDisplayHtml( originalDesc ) }</span>
                    <button type="button" class="custom-remove-btn icon-file-close hidden">Remove</button>
                </div>
            ` );
				}

				// 3. NEW: Check if a file already exists (Post-Validation State)
				// GF places existing files in .ginput_preview or list items
				const $existingFile = $thisContainer.find(
					'.ginput_preview, .gform_file_upload_item, input[type="hidden"][name^="gform_uploaded_files"]'
				);

				if ( $existingFile.length > 0 ) {
					const $customContent = $thisContainer.find(
						'.custom-upload-content'
					);
					const $textSpan = $customContent.find(
						'.custom-upload-text'
					);
					const $removeBtn =
						$customContent.find( '.custom-remove-btn' );

					// Find the filename: GF usually puts it inside a <strong> or text node in the preview
					let fileName = $thisContainer
						.find(
							'.gfield_fileupload_filename'
						)
						.text();

					// If we found a file, update the UI
					if ( fileName || $existingFile.length > 0 ) {
						console.log( $textSpan );

						$parentField.addClass( 'has-file' );
						$removeBtn.removeClass( 'hidden' );
						$textSpan
							.text( fileName ? fileName : 'File uploaded' );
						$thisContainer.find( '.ginput_preview' ).hide();
						$thisContainer
							.find( 'input[type="file"]' )
							.removeClass( 'gform_hidden' );
					}
				}
			} );
		}

		// Wrap "(required)" / "(optional)" text in labels for get-in-touch styling.
		// For optional fields GF outputs no indicator at all — we inject one.
		function wrapLabelQualifiers() {
			if ( ! $( '.get-in-touch-page' ).length ) return;

			$( '.get-in-touch-page .gfield' )
				.not( '.gfield--type-fileupload' )
				.not( '.gfield--type-honeypot' )
				.not( '.gfield--type-captcha' )
				.not( '.hidden' )
				.each( function () {
					const $field = $( this );
					const $label = $field.find( '.gfield_label' ).first();
					if ( ! $label.length ) return;

					// Skip already-processed labels
					if ( $label.find( '.label-qualifier' ).length ) return;

					// Optional fields have no .gfield_required child — inject the text
					if ( ! $label.find( '.gfield_required' ).length ) {
						$label.append(
							'<span class="label-qualifier"> (optional)</span>'
						);
					}

					// Wrap any inline (required)/(optional) text patterns
					const html = $label.html();
					const updated = html.replace(
						/(\((required|optional)\))/gi,
						'<span class="label-qualifier">$1</span>'
					);
					if ( updated !== html ) $label.html( updated );
				} );
		}

		// Inject "Max 5 MB" hint below compact upload control on get-in-touch page
		function injectUploadSizeHint() {
			if ( ! $( '.get-in-touch-page' ).length ) return;
			$( '.get-in-touch-page .ginput_container_fileupload' ).each( function () {
				const $container = $( this );
				if ( $container.siblings( '.upload-size-hint' ).length ) return;
				$container.after(
					'<span class="upload-size-hint">Max 5 MB</span>'
				);
			} );
		}

		// Build upload display HTML — wraps (optional) in label-qualifier on get-in-touch
		function uploadDisplayHtml( text ) {
			if ( ! $( '.get-in-touch-page' ).length ) return text;
			return text.replace(
				/(\(optional\))/gi,
				'<span class="label-qualifier">$1</span>'
			);
		}

		wrapLabelQualifiers();
		injectUploadSizeHint();

		// 2. Bind to the Gravity Forms post-render event
		$( document ).on(
			'gform_post_render',
			function ( event, formId, currentPage ) {
				initCustomUploads( formId );
				$( 'form select:not(#mobile-choice)' ).niceSelect();
				wrapLabelQualifiers();
				injectUploadSizeHint();
			}
		);

		function getUploadText( $field ) {
			const isMobile = window.innerWidth <= 768;

			if ( $( '.get-in-touch-page' ).length ) {
				return 'Attach a brief (optional)';
			}

			if ( isMobile ) return 'Tap to upload a file. Max size 5MB.';

			// Target the specific description while avoiding the validation error text
			return $field
				.closest( '.gfield' )
				.find( '.gfield_description' )
				.not( '.gfield_validation_message, .gform_fileupload_rules' )
				.first()
				.text();
		}

		$containers.each( function () {
			const $thisContainer = $( this );
			const $parentField = $thisContainer.closest( '.gfield' );
			const originalDesc = getUploadText( $thisContainer );

			// 1. Hide original descriptions and rules
			$parentField
				.find( '.gfield_description, .gform_fileupload_rules' )
				.not( '.gfield_validation_message' )
				.hide();

			// 2. Only inject if not already there (prevents duplicates on AJAX reloads)
			if (
				$thisContainer.find( '.custom-upload-content' ).length === 0
			) {
				$thisContainer.prepend( `
                <div class="custom-upload-content">
                    <span class="custom-upload-icon icon-attachment"></span>
                    <span class="custom-upload-text" data-original-text="${ originalDesc }">${ uploadDisplayHtml( originalDesc ) }</span>
                    <button type="button" class="custom-remove-btn icon-file-close hidden">Remove</button>
                </div>
            ` );
			}
		} );

		// Handle File Change
		$( document ).on(
			'change',
			'.ginput_container_fileupload input[type="file"]',
			function () {
				const $input = $( this );
				const $container = $input.closest(
					'.ginput_container_fileupload'
				);
				const fileName = $input.val().split( '\\' ).pop();

				if ( fileName ) {
					$container
						.find( '.custom-upload-text' )
						.text( fileName )
						.css( 'color', '#fff' );
					$input.closest( '.gfield' ).addClass( 'has-file' );
					$container
						.find( '.custom-remove-btn' )
						.removeClass( 'hidden' );
				}
			}
		);

		// Handle Remove Button
		$( document ).on( 'click', '.custom-remove-btn', function ( e ) {
			e.preventDefault();
			const $btn = $( this );
			const $container = $btn.closest( '.ginput_container_fileupload' );
			const $textSpan = $container.find( '.custom-upload-text' );
			const originalText = $textSpan.data( 'original-text' );

			$container.find( 'input[type="file"]' ).val( '' );
			$textSpan.html( uploadDisplayHtml( originalText ) ).css( 'color', '' );
			$btn.closest( '.gfield' ).removeClass( 'has-file' );
			$btn.addClass( 'hidden' );
		} );

		const textareas = document.querySelectorAll( 'textarea' );

		textareas.forEach( ( el ) => {
			el.addEventListener(
				'blur',
				() => {
					el.classList.add( 'was-focused' );
				},
				{ once: true }
			); // 'once: true' automatically removes the listener after it runs
		} );
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
